export class KeyCodes {
    static capslock = 20;
    static shift = 16;
    static alt = 18;
    static enter = 13;
    static ctrl = 17;
    static select = 93;
    static leftwindow = 91;
    static leftarrow = 37;
    static uparrow = 38;
    static rightarrow = 39;
    static downarrow = 40;
    static F9 = 120;
    static F12 = 123;
    static backspace = 8;
    static escape = 27;
}
